import { registerBlockType } from "@wordpress/blocks";
import {
  MediaUpload,
  MediaUploadCheck,
  InspectorControls,
} from "@wordpress/block-editor";
import { PanelBody, Button, TextControl } from "@wordpress/components";
import { Fragment } from "@wordpress/element";

registerBlockType("monfort/bootstrap-carousel", {
  title: "monfort Bootstrap Carousel",
  category: "design",
  icon: "format-gallery",
  description: "A Bootstrap 5 Carousel with dynamic images in full width",
  supports: {
    html: false,
  },
  attributes: {
    carouselId: {
      type: "string",
      default: "carousel-1",
    },
    images: {
      type: "array",
      default: [],
      items: {
        type: "object",
      },
    },
  },
  edit: ({ attributes, setAttributes }) => {
    const { carouselId, images } = attributes;

    const onSelectImages = (newImages) => {
      setAttributes({
        images: newImages.map((img) => ({ id: img.id, url: img.url })),
      });
    };

    return (
      <Fragment>
        <InspectorControls>
          <PanelBody title="Carousel Settings">
            <TextControl
              label="Carousel ID"
              value={carouselId}
              onChange={(value) => setAttributes({ carouselId: value })}
              help="Must be unique on the page"
            />
          </PanelBody>
        </InspectorControls>

        <div className="bootstrap-carousel-editor">
          <MediaUploadCheck>
            <MediaUpload
              onSelect={onSelectImages}
              allowedTypes={["image"]}
              multiple
              gallery
              value={images.map((img) => img.id)}
              render={({ open }) => (
                <Button onClick={open} variant="primary">
                  {images.length > 0 ? "Edit Images" : "Select Images"}
                </Button>
              )}
            />
          </MediaUploadCheck>

          <div className="carousel-preview">
            {images.map((img, index) => (
              <img
                key={index}
                src={img.url}
                alt=""
                style={{ maxWidth: "100px", marginRight: "5px" }}
              />
            ))}
          </div>
        </div>
      </Fragment>
    );
  },

  save: ({ attributes }) => {
    const { carouselId, images } = attributes;
    return (
      <div id={carouselId} className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          {images.map((img, index) => (
            <div
              className={`carousel-item${index === 0 ? " active" : ""}`}
              key={index}
            >
              <img
                loading="lazy"
                className="d-block w-100"
                src={img.url}
                alt=""
              />
            </div>
          ))}
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target={`#${carouselId}`}
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target={`#${carouselId}`}
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    );
  },
});
